import React from "react";

const SvgFacebook = props => (
  <svg viewBox="9 -6 26 25" {...props}>
    <path d="M9.1 18.1V-6h25v24h-7.7v-.2V11 9.1c0-.3 0-.4.3-.4h2.6c.3 0 .3 0 .4-.3.1-.9.2-1.8.4-2.7 0-.3.1-.5.1-.8h-3.5c-.2 0-.3-.1-.3-.3V2.4 2c0-.3.1-.5.3-.7.4-.3.8-.4 1.2-.4h1.9c.3 0 .4 0 .4-.3v-1.9-.9c0-.2-.1-.3-.3-.3h-3c-1.4 0-2.6.5-3.5 1.5-.4.4-.6.9-.8 1.4-.2.4-.2.9-.2 1.3v2.8c0 .5-.1.5-.4.5h-2.7c-.3 0-.3 0-.3.3v3.3c0 .3 0 .3.3.3H22c.2 0 .3 0 .3.3V18.2H9.2c0-.1-.1-.1-.1-.1z" />
  </svg>
);

export default SvgFacebook;
